/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AutoCompleteListingAddress,
  CreateOfferRequest,
  CreateOfferResponse,
  CreateOfferTermsRequest,
  CreatePublicTransactionRequest,
  DocClassificationResponse,
  HTTPValidationError,
  HomeownershipAdvisorRequest,
  HomeownershipConsentWithdrawRequest,
  HomeownershipInterestRequest,
  HomeownershipLastLookAnswerRequest,
  HomeownershipLenderRequest,
  HomeownershipLockRequest,
  HomeownershipPageRequest,
  HomeownershipPageResponse,
  HomeownershipPassRequest,
  HomeownershipTermsAcceptRequest,
  HomeownershipTermsDeclineRequest,
  Offer,
  OfferTerms,
  PrewalkAgentResultsRequest,
  PublicCounterTransactionRequest,
  PublicOffer,
  PublicSharedDocumentResponse,
  PublicTransactionDocumentResponse,
  PublicUpdateOfferRequest,
  PublicUser,
  PublicUserLicenseInfo,
  ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost,
  TransactionResponse,
  UpdateOfferTermsRequest,
  UploadOfferDocumentsResponse,
} from '../models/index';
import {
    AutoCompleteListingAddressFromJSON,
    AutoCompleteListingAddressToJSON,
    CreateOfferRequestFromJSON,
    CreateOfferRequestToJSON,
    CreateOfferResponseFromJSON,
    CreateOfferResponseToJSON,
    CreateOfferTermsRequestFromJSON,
    CreateOfferTermsRequestToJSON,
    CreatePublicTransactionRequestFromJSON,
    CreatePublicTransactionRequestToJSON,
    DocClassificationResponseFromJSON,
    DocClassificationResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    HomeownershipAdvisorRequestFromJSON,
    HomeownershipAdvisorRequestToJSON,
    HomeownershipConsentWithdrawRequestFromJSON,
    HomeownershipConsentWithdrawRequestToJSON,
    HomeownershipInterestRequestFromJSON,
    HomeownershipInterestRequestToJSON,
    HomeownershipLastLookAnswerRequestFromJSON,
    HomeownershipLastLookAnswerRequestToJSON,
    HomeownershipLenderRequestFromJSON,
    HomeownershipLenderRequestToJSON,
    HomeownershipLockRequestFromJSON,
    HomeownershipLockRequestToJSON,
    HomeownershipPageRequestFromJSON,
    HomeownershipPageRequestToJSON,
    HomeownershipPageResponseFromJSON,
    HomeownershipPageResponseToJSON,
    HomeownershipPassRequestFromJSON,
    HomeownershipPassRequestToJSON,
    HomeownershipTermsAcceptRequestFromJSON,
    HomeownershipTermsAcceptRequestToJSON,
    HomeownershipTermsDeclineRequestFromJSON,
    HomeownershipTermsDeclineRequestToJSON,
    OfferFromJSON,
    OfferToJSON,
    OfferTermsFromJSON,
    OfferTermsToJSON,
    PrewalkAgentResultsRequestFromJSON,
    PrewalkAgentResultsRequestToJSON,
    PublicCounterTransactionRequestFromJSON,
    PublicCounterTransactionRequestToJSON,
    PublicOfferFromJSON,
    PublicOfferToJSON,
    PublicSharedDocumentResponseFromJSON,
    PublicSharedDocumentResponseToJSON,
    PublicTransactionDocumentResponseFromJSON,
    PublicTransactionDocumentResponseToJSON,
    PublicUpdateOfferRequestFromJSON,
    PublicUpdateOfferRequestToJSON,
    PublicUserFromJSON,
    PublicUserToJSON,
    PublicUserLicenseInfoFromJSON,
    PublicUserLicenseInfoToJSON,
    ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostFromJSON,
    ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostToJSON,
    TransactionResponseFromJSON,
    TransactionResponseToJSON,
    UpdateOfferTermsRequestFromJSON,
    UpdateOfferTermsRequestToJSON,
    UploadOfferDocumentsResponseFromJSON,
    UploadOfferDocumentsResponseToJSON,
} from '../models/index';

export interface AuthenticateSessionApiV1PublicAuthSessionGetRequest {
    token?: string;
    redirectUrl?: string;
}

export interface AutoCompleteListingsApiV1PublicListingsAutoCompleteGetRequest {
    q: string;
}

export interface ClassifyPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsClassifyPostRequest {
    transactionId: string;
    file: Blob;
}

export interface CreateOfferApiV1PublicOffersPostRequest {
    createOfferRequest: CreateOfferRequest;
}

export interface CreateOfferTermsApiV1PublicOffersOfferIdTermsPostRequest {
    offerId: string;
    createOfferTermsRequest: CreateOfferTermsRequest;
}

export interface CreatePublicTransactionApiV1PublicTransactionsPostRequest {
    createPublicTransactionRequest: CreatePublicTransactionRequest;
}

export interface CreatePublicTransactionCounterApiV1PublicTransactionsTransactionIdCounterPostRequest {
    transactionId: string;
    publicCounterTransactionRequest: PublicCounterTransactionRequest;
}

export interface GetOfferDocumentApiV1PublicOffersOfferIdDocumentsDocumentIdGetRequest {
    offerId: string;
    documentId: string;
}

export interface GetOffersApiV1PublicOffersGetRequest {
    offerIds?: Array<string>;
}

export interface GetPublicTransactionByOfferIdApiV1PublicTransactionsByOfferOfferIdGetRequest {
    offerId: string;
}

export interface GetPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsDocumentIdGetRequest {
    transactionId: string;
    documentId: string;
}

export interface GetSharedDispositionDocumentApiV1PublicDispositionsDispositionIdSharedDocumentsDocIdGetRequest {
    dispositionId: string;
    docId: string;
}

export interface GetUserLicenseApiV1PublicUsersUserIdLicenseGetRequest {
    userId: string;
    state: string;
}

export interface HomeownershipAdvisorRequestApiV1PublicHomeownershipAdvisorRequestPostRequest {
    homeownershipAdvisorRequest: HomeownershipAdvisorRequest;
}

export interface HomeownershipChangeMindApiV1PublicHomeownershipChangeMindPostRequest {
    homeownershipPageRequest: HomeownershipPageRequest;
}

export interface HomeownershipConsentWithdrawApiV1PublicHomeownershipConsentWithdrawPostRequest {
    homeownershipConsentWithdrawRequest: HomeownershipConsentWithdrawRequest;
}

export interface HomeownershipInterestApiV1PublicHomeownershipInterestPostRequest {
    homeownershipInterestRequest: HomeownershipInterestRequest;
}

export interface HomeownershipLastLookAnswerApiV1PublicHomeownershipLastLookAnswerPostRequest {
    homeownershipLastLookAnswerRequest: HomeownershipLastLookAnswerRequest;
}

export interface HomeownershipLenderConsentApiV1PublicHomeownershipConsentLenderVVersionConnectionGetRequest {
    version: number;
    connection: string;
}

export interface HomeownershipLenderRequestApiV1PublicHomeownershipLenderRequestPostRequest {
    homeownershipLenderRequest: HomeownershipLenderRequest;
}

export interface HomeownershipLockApiV1PublicHomeownershipLockPostRequest {
    homeownershipLockRequest: HomeownershipLockRequest;
}

export interface HomeownershipOptOutApiV1PublicHomeownershipOptOutPostRequest {
    homeownershipPageRequest: HomeownershipPageRequest;
}

export interface HomeownershipOptOutPageApiV1PublicHomeownershipOptOutPagePostRequest {
    homeownershipPageRequest: HomeownershipPageRequest;
}

export interface HomeownershipPageApiV1PublicHomeownershipPagePostRequest {
    homeownershipPageRequest: HomeownershipPageRequest;
}

export interface HomeownershipPageOpenedApiV1PublicHomeownershipPageOpenedPostRequest {
    homeownershipPageRequest: HomeownershipPageRequest;
}

export interface HomeownershipPassApiV1PublicHomeownershipPassPostRequest {
    homeownershipPassRequest: HomeownershipPassRequest;
}

export interface HomeownershipTermsAcceptApiV1PublicHomeownershipTermsAcceptPostRequest {
    homeownershipTermsAcceptRequest: HomeownershipTermsAcceptRequest;
}

export interface HomeownershipTermsDeclineApiV1PublicHomeownershipTermsDeclinePostRequest {
    homeownershipTermsDeclineRequest: HomeownershipTermsDeclineRequest;
}

export interface ListPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsGetRequest {
    transactionId: string;
}

export interface ListSharedDispositionDocumentsApiV1PublicDispositionsDispositionIdSharedDocumentsGetRequest {
    dispositionId: string;
}

export interface PrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostRequest {
    prewalkAgentResultsRequest: PrewalkAgentResultsRequest;
}

export interface SendAuthTokenEmailApiV1PublicAuthEmailGetRequest {
    email: string;
    redirectUrl?: string;
}

export interface UpdateOfferApiV1PublicOffersOfferIdPatchRequest {
    offerId: string;
    publicUpdateOfferRequest: PublicUpdateOfferRequest;
}

export interface UpdateOfferTermsApiV1PublicOffersTermsTermsIdPatchRequest {
    termsId: string;
    updateOfferTermsRequest: UpdateOfferTermsRequest;
}

export interface UploadOfferDocumentsApiV1PublicOffersOfferIdDocumentsPostRequest {
    offerId: string;
    files: Array<Blob>;
}

export interface UploadPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsPostRequest {
    transactionId: string;
    file: Blob;
    docType?: string;
}

export interface WithdrawPublicTransactionApiV1PublicTransactionsTransactionIdWithdrawPostRequest {
    transactionId: string;
}

/**
 * 
 */
export class PublicApi extends runtime.BaseAPI {

    /**
     * Authenticate Session
     */
    async authenticateSessionApiV1PublicAuthSessionGetRaw(requestParameters: AuthenticateSessionApiV1PublicAuthSessionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        if (requestParameters.token !== undefined) {
            queryParameters['token'] = requestParameters.token;
        }

        if (requestParameters.redirectUrl !== undefined) {
            queryParameters['redirect_url'] = requestParameters.redirectUrl;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/auth/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Authenticate Session
     */
    async authenticateSessionApiV1PublicAuthSessionGet(requestParameters: AuthenticateSessionApiV1PublicAuthSessionGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.authenticateSessionApiV1PublicAuthSessionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Combined listing + disposition autocomplete for the consumer offer form.  Returns a deduped list tagged with `kind`. Dispositions are emitted first (canonical address from disposition→property.address_str, `kind=\'disposition\'`, carrying `disposition_id`) so a property with BOTH a live disposition and a listing surfaces only the disposition entry (routes to the 2.0 txn submit). Listings whose address already appears as a disposition are dropped; the rest keep their 1.0 metadata (list_price/listing_status/highest_and_best_deadline) and route to the 1.0 offer path. Dedup is by normalized address string — the only consistency signal across the two sources (no property→listing FK).
     * Auto Complete Listings
     */
    async autoCompleteListingsApiV1PublicListingsAutoCompleteGetRaw(requestParameters: AutoCompleteListingsApiV1PublicListingsAutoCompleteGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AutoCompleteListingAddress>>> {
        if (requestParameters.q === null || requestParameters.q === undefined) {
            throw new runtime.RequiredError('q','Required parameter requestParameters.q was null or undefined when calling autoCompleteListingsApiV1PublicListingsAutoCompleteGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.q !== undefined) {
            queryParameters['q'] = requestParameters.q;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/listings/auto-complete`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AutoCompleteListingAddressFromJSON));
    }

    /**
     * Combined listing + disposition autocomplete for the consumer offer form.  Returns a deduped list tagged with `kind`. Dispositions are emitted first (canonical address from disposition→property.address_str, `kind=\'disposition\'`, carrying `disposition_id`) so a property with BOTH a live disposition and a listing surfaces only the disposition entry (routes to the 2.0 txn submit). Listings whose address already appears as a disposition are dropped; the rest keep their 1.0 metadata (list_price/listing_status/highest_and_best_deadline) and route to the 1.0 offer path. Dedup is by normalized address string — the only consistency signal across the two sources (no property→listing FK).
     * Auto Complete Listings
     */
    async autoCompleteListingsApiV1PublicListingsAutoCompleteGet(requestParameters: AutoCompleteListingsApiV1PublicListingsAutoCompleteGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AutoCompleteListingAddress>> {
        const response = await this.autoCompleteListingsApiV1PublicListingsAutoCompleteGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Suggest a doc type for a file the buyer is about to upload.  The public half of ``POST /api/v1/docs/classify``: same :class:`DocClassificationService`, same ``transaction`` scope, but reached with a buyer session instead of ``mtx:documents.upload`` and scoped to one transaction the caller owns. Session auth is REQUIRED here even though the upload route it feeds accepts anonymous calls -- classification runs a paid model, so it must not be an open endpoint.  Stateless: nothing is persisted, and the suggestion is only a default. The buyer picks the type that is actually sent to the upload route, which validates it independently.  A suggestion outside ``PUBLIC_SUBMITTABLE_DOCUMENT_TYPES`` comes back as ``None`` rather than as a type the upload route would reject -- the classifier\'s transaction vocabulary is wider than the buyer-submittable set (closing_statement, commission_instructions and the rest), and the reason is kept so the clamp is visible.
     * Classify Public Transaction Document
     */
    async classifyPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsClassifyPostRaw(requestParameters: ClassifyPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsClassifyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocClassificationResponse>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling classifyPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsClassifyPost.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling classifyPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsClassifyPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/v1/public/transactions/{transaction_id}/documents/classify`.replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocClassificationResponseFromJSON(jsonValue));
    }

    /**
     * Suggest a doc type for a file the buyer is about to upload.  The public half of ``POST /api/v1/docs/classify``: same :class:`DocClassificationService`, same ``transaction`` scope, but reached with a buyer session instead of ``mtx:documents.upload`` and scoped to one transaction the caller owns. Session auth is REQUIRED here even though the upload route it feeds accepts anonymous calls -- classification runs a paid model, so it must not be an open endpoint.  Stateless: nothing is persisted, and the suggestion is only a default. The buyer picks the type that is actually sent to the upload route, which validates it independently.  A suggestion outside ``PUBLIC_SUBMITTABLE_DOCUMENT_TYPES`` comes back as ``None`` rather than as a type the upload route would reject -- the classifier\'s transaction vocabulary is wider than the buyer-submittable set (closing_statement, commission_instructions and the rest), and the reason is kept so the clamp is visible.
     * Classify Public Transaction Document
     */
    async classifyPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsClassifyPost(requestParameters: ClassifyPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsClassifyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocClassificationResponse> {
        const response = await this.classifyPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsClassifyPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Offer
     */
    async createOfferApiV1PublicOffersPostRaw(requestParameters: CreateOfferApiV1PublicOffersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOfferResponse>> {
        if (requestParameters.createOfferRequest === null || requestParameters.createOfferRequest === undefined) {
            throw new runtime.RequiredError('createOfferRequest','Required parameter requestParameters.createOfferRequest was null or undefined when calling createOfferApiV1PublicOffersPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/offers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOfferRequestToJSON(requestParameters.createOfferRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOfferResponseFromJSON(jsonValue));
    }

    /**
     * Create Offer
     */
    async createOfferApiV1PublicOffersPost(requestParameters: CreateOfferApiV1PublicOffersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOfferResponse> {
        const response = await this.createOfferApiV1PublicOffersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Offer Terms
     */
    async createOfferTermsApiV1PublicOffersOfferIdTermsPostRaw(requestParameters: CreateOfferTermsApiV1PublicOffersOfferIdTermsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferTerms>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling createOfferTermsApiV1PublicOffersOfferIdTermsPost.');
        }

        if (requestParameters.createOfferTermsRequest === null || requestParameters.createOfferTermsRequest === undefined) {
            throw new runtime.RequiredError('createOfferTermsRequest','Required parameter requestParameters.createOfferTermsRequest was null or undefined when calling createOfferTermsApiV1PublicOffersOfferIdTermsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/offers/{offer_id}/terms`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOfferTermsRequestToJSON(requestParameters.createOfferTermsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OfferTermsFromJSON(jsonValue));
    }

    /**
     * Create Offer Terms
     */
    async createOfferTermsApiV1PublicOffersOfferIdTermsPost(requestParameters: CreateOfferTermsApiV1PublicOffersOfferIdTermsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferTerms> {
        const response = await this.createOfferTermsApiV1PublicOffersOfferIdTermsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * External consumer offer submit → native transaction (unauth).  Mirrors `POST /api/v1/public/offers`: anonymous submit, the buyer\'s PublicUser is created/looked up implicitly and carried onto the transaction (`public_user_id`) so they can return via magic-link. Consumer auto-reject guards + the new-offer ack email run inside the service.  The payload build is shared with the operator submit (`POST /api/v1/transactions/submit`) — see `_consumer_submit_payload`. An unauthenticated submit always acknowledges; a request carrying an operator identity honours `send_email`, matching `OfferService.create_offer`\'s gate. `manual_entry_reason` is operator provenance and is dropped on an anonymous submit for the same reason `_consumer_submit_payload` drops the rest of that block.
     * Create Public Transaction
     */
    async createPublicTransactionApiV1PublicTransactionsPostRaw(requestParameters: CreatePublicTransactionApiV1PublicTransactionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionResponse>> {
        if (requestParameters.createPublicTransactionRequest === null || requestParameters.createPublicTransactionRequest === undefined) {
            throw new runtime.RequiredError('createPublicTransactionRequest','Required parameter requestParameters.createPublicTransactionRequest was null or undefined when calling createPublicTransactionApiV1PublicTransactionsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/transactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePublicTransactionRequestToJSON(requestParameters.createPublicTransactionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionResponseFromJSON(jsonValue));
    }

    /**
     * External consumer offer submit → native transaction (unauth).  Mirrors `POST /api/v1/public/offers`: anonymous submit, the buyer\'s PublicUser is created/looked up implicitly and carried onto the transaction (`public_user_id`) so they can return via magic-link. Consumer auto-reject guards + the new-offer ack email run inside the service.  The payload build is shared with the operator submit (`POST /api/v1/transactions/submit`) — see `_consumer_submit_payload`. An unauthenticated submit always acknowledges; a request carrying an operator identity honours `send_email`, matching `OfferService.create_offer`\'s gate. `manual_entry_reason` is operator provenance and is dropped on an anonymous submit for the same reason `_consumer_submit_payload` drops the rest of that block.
     * Create Public Transaction
     */
    async createPublicTransactionApiV1PublicTransactionsPost(requestParameters: CreatePublicTransactionApiV1PublicTransactionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionResponse> {
        const response = await this.createPublicTransactionApiV1PublicTransactionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public buyer counter response → ``create_counter_terms(source=BUYER)``.  Session-authed (magic-link). Mirrors the 1.0 ``POST /offers/{id}/terms`` buyer counter: validates PublicUser ownership, then routes through the existing service method with ``source=BUYER`` hard-wired (the consumer can never spoof a seller counter). The service rotates terms, flips status to COUNTER_RECEIVED, records the activity row, spawns the seller-side review task, and dispatches the buyer-countered email.
     * Create Public Transaction Counter
     */
    async createPublicTransactionCounterApiV1PublicTransactionsTransactionIdCounterPostRaw(requestParameters: CreatePublicTransactionCounterApiV1PublicTransactionsTransactionIdCounterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionResponse>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling createPublicTransactionCounterApiV1PublicTransactionsTransactionIdCounterPost.');
        }

        if (requestParameters.publicCounterTransactionRequest === null || requestParameters.publicCounterTransactionRequest === undefined) {
            throw new runtime.RequiredError('publicCounterTransactionRequest','Required parameter requestParameters.publicCounterTransactionRequest was null or undefined when calling createPublicTransactionCounterApiV1PublicTransactionsTransactionIdCounterPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/transactions/{transaction_id}/counter`.replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublicCounterTransactionRequestToJSON(requestParameters.publicCounterTransactionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionResponseFromJSON(jsonValue));
    }

    /**
     * Public buyer counter response → ``create_counter_terms(source=BUYER)``.  Session-authed (magic-link). Mirrors the 1.0 ``POST /offers/{id}/terms`` buyer counter: validates PublicUser ownership, then routes through the existing service method with ``source=BUYER`` hard-wired (the consumer can never spoof a seller counter). The service rotates terms, flips status to COUNTER_RECEIVED, records the activity row, spawns the seller-side review task, and dispatches the buyer-countered email.
     * Create Public Transaction Counter
     */
    async createPublicTransactionCounterApiV1PublicTransactionsTransactionIdCounterPost(requestParameters: CreatePublicTransactionCounterApiV1PublicTransactionsTransactionIdCounterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionResponse> {
        const response = await this.createPublicTransactionCounterApiV1PublicTransactionsTransactionIdCounterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Current Session User
     */
    async getCurrentSessionUserApiV1PublicAuthMeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/auth/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicUserFromJSON(jsonValue));
    }

    /**
     * Get Current Session User
     */
    async getCurrentSessionUserApiV1PublicAuthMeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicUser> {
        const response = await this.getCurrentSessionUserApiV1PublicAuthMeGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Offer Document
     */
    async getOfferDocumentApiV1PublicOffersOfferIdDocumentsDocumentIdGetRaw(requestParameters: GetOfferDocumentApiV1PublicOffersOfferIdDocumentsDocumentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling getOfferDocumentApiV1PublicOffersOfferIdDocumentsDocumentIdGet.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling getOfferDocumentApiV1PublicOffersOfferIdDocumentsDocumentIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/offers/{offer_id}/documents/{document_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get Offer Document
     */
    async getOfferDocumentApiV1PublicOffersOfferIdDocumentsDocumentIdGet(requestParameters: GetOfferDocumentApiV1PublicOffersOfferIdDocumentsDocumentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getOfferDocumentApiV1PublicOffersOfferIdDocumentsDocumentIdGetRaw(requestParameters, initOverrides);
    }

    /**
     * Get Offers
     */
    async getOffersApiV1PublicOffersGetRaw(requestParameters: GetOffersApiV1PublicOffersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PublicOffer>>> {
        const queryParameters: any = {};

        if (requestParameters.offerIds) {
            queryParameters['offer_ids'] = requestParameters.offerIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/offers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PublicOfferFromJSON));
    }

    /**
     * Get Offers
     */
    async getOffersApiV1PublicOffersGet(requestParameters: GetOffersApiV1PublicOffersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PublicOffer>> {
        const response = await this.getOffersApiV1PublicOffersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a legacy 1.0 offer id to its transaction.  Declared BEFORE every `/transactions/{transaction_id}` route below: FastAPI matches in registration order, so a `{transaction_id}`-shaped sibling declared first would swallow the literal `by-offer` segment.  Emails already in buyers\' inboxes link to `{OFFERS_UI_HOST}/offers/{offer.id}` (`email_template_repository.py`) and cannot be rewritten, so the native site resolves that id here and redirects. `transactions.offer_id` is the dual-write mirror FK, populated on every transaction mirrored from a 1.0 offer; a natively-created (post-cutover) transaction has none, and no email links to one for it.  Session-authed: a valid session cannot resolve someone else\'s offer. Ownership is asserted locally rather than through `_get_owned_transaction` because that helper\'s 403 message names the transaction id, and the exception handler returns `exc.args[0]` verbatim — the caller supplied only the offer id, and offer ids ride in forwarded buyer emails. The session-less arm of the sibling upload route accepts a bare transaction id, so echoing one back is handing out a write capability. Both arms therefore raise the SAME 404 body: \"mapped to another buyer\" and \"no such mapping\" must be indistinguishable, or the 403/404 split is an existence oracle over which offers are mirrored. The ids stay in the structlog line.  Returns the full response (`redact_client_decision=True`, matching every other buyer-facing read) so the redirect renders the detail page without a second round trip.
     * Get Public Transaction By Offer Id
     */
    async getPublicTransactionByOfferIdApiV1PublicTransactionsByOfferOfferIdGetRaw(requestParameters: GetPublicTransactionByOfferIdApiV1PublicTransactionsByOfferOfferIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionResponse>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling getPublicTransactionByOfferIdApiV1PublicTransactionsByOfferOfferIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/transactions/by-offer/{offer_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionResponseFromJSON(jsonValue));
    }

    /**
     * Resolve a legacy 1.0 offer id to its transaction.  Declared BEFORE every `/transactions/{transaction_id}` route below: FastAPI matches in registration order, so a `{transaction_id}`-shaped sibling declared first would swallow the literal `by-offer` segment.  Emails already in buyers\' inboxes link to `{OFFERS_UI_HOST}/offers/{offer.id}` (`email_template_repository.py`) and cannot be rewritten, so the native site resolves that id here and redirects. `transactions.offer_id` is the dual-write mirror FK, populated on every transaction mirrored from a 1.0 offer; a natively-created (post-cutover) transaction has none, and no email links to one for it.  Session-authed: a valid session cannot resolve someone else\'s offer. Ownership is asserted locally rather than through `_get_owned_transaction` because that helper\'s 403 message names the transaction id, and the exception handler returns `exc.args[0]` verbatim — the caller supplied only the offer id, and offer ids ride in forwarded buyer emails. The session-less arm of the sibling upload route accepts a bare transaction id, so echoing one back is handing out a write capability. Both arms therefore raise the SAME 404 body: \"mapped to another buyer\" and \"no such mapping\" must be indistinguishable, or the 403/404 split is an existence oracle over which offers are mirrored. The ids stay in the structlog line.  Returns the full response (`redact_client_decision=True`, matching every other buyer-facing read) so the redirect renders the detail page without a second round trip.
     * Get Public Transaction By Offer Id
     */
    async getPublicTransactionByOfferIdApiV1PublicTransactionsByOfferOfferIdGet(requestParameters: GetPublicTransactionByOfferIdApiV1PublicTransactionsByOfferOfferIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionResponse> {
        const response = await this.getPublicTransactionByOfferIdApiV1PublicTransactionsByOfferOfferIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download one document from the buyer\'s own transaction.  A session is REQUIRED here, unlike the sibling upload route: that route allows a session-less call for 1.0 parity (a buyer attaches docs immediately post-submit, before a magic-link session exists), but a session-less GET would let anyone holding two UUIDs pull a buyer\'s purchase contract.  Two authorization checks, both required. `_get_owned_transaction` proves the session\'s PublicUser owns the transaction in the path; `_public_visible_docs` is transaction-scoped, so a `document_id` belonging to a DIFFERENT transaction is simply absent and 404s. Without the second check any authenticated buyer session could fetch any transaction\'s documents by guessing a UUID pair — the same attack the frozen 1.0 route\'s ownership filter prevents.  `document_id` addresses the SUBMISSION record, matching what the list hands out. Matching on `doc_id` instead resolved every file of a same-typed submission to whichever one listed first, which is the shape of the bug this table exists to fix.
     * Get Public Transaction Document
     */
    async getPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsDocumentIdGetRaw(requestParameters: GetPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsDocumentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling getPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsDocumentIdGet.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling getPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsDocumentIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/transactions/{transaction_id}/documents/{document_id}`.replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters.transactionId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download one document from the buyer\'s own transaction.  A session is REQUIRED here, unlike the sibling upload route: that route allows a session-less call for 1.0 parity (a buyer attaches docs immediately post-submit, before a magic-link session exists), but a session-less GET would let anyone holding two UUIDs pull a buyer\'s purchase contract.  Two authorization checks, both required. `_get_owned_transaction` proves the session\'s PublicUser owns the transaction in the path; `_public_visible_docs` is transaction-scoped, so a `document_id` belonging to a DIFFERENT transaction is simply absent and 404s. Without the second check any authenticated buyer session could fetch any transaction\'s documents by guessing a UUID pair — the same attack the frozen 1.0 route\'s ownership filter prevents.  `document_id` addresses the SUBMISSION record, matching what the list hands out. Matching on `doc_id` instead resolved every file of a same-typed submission to whichever one listed first, which is the shape of the bug this table exists to fix.
     * Get Public Transaction Document
     */
    async getPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsDocumentIdGet(requestParameters: GetPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsDocumentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPublicTransactionDocumentApiV1PublicTransactionsTransactionIdDocumentsDocumentIdGetRaw(requestParameters, initOverrides);
    }

    /**
     * Public buyer status read — the buyer\'s offer-type transactions.  Session-authed (magic-link). Mirrors `get_offers` → `get_offers_by_public_user_id`: resolves the PublicUser from the session cookie and returns transactions scoped to that public_user_id.
     * Get Public Transactions
     */
    async getPublicTransactionsApiV1PublicTransactionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TransactionResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/transactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TransactionResponseFromJSON));
    }

    /**
     * Public buyer status read — the buyer\'s offer-type transactions.  Session-authed (magic-link). Mirrors `get_offers` → `get_offers_by_public_user_id`: resolves the PublicUser from the session cookie and returns transactions scoped to that public_user_id.
     * Get Public Transactions
     */
    async getPublicTransactionsApiV1PublicTransactionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TransactionResponse>> {
        const response = await this.getPublicTransactionsApiV1PublicTransactionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Stream one shared listing document to an anonymous buyer agent.  Streams the current version after rechecking the same visibility and storage policy as the list. Uploads and signing changes become visible without another sharing action.
     * Get Shared Disposition Document
     */
    async getSharedDispositionDocumentApiV1PublicDispositionsDispositionIdSharedDocumentsDocIdGetRaw(requestParameters: GetSharedDispositionDocumentApiV1PublicDispositionsDispositionIdSharedDocumentsDocIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dispositionId === null || requestParameters.dispositionId === undefined) {
            throw new runtime.RequiredError('dispositionId','Required parameter requestParameters.dispositionId was null or undefined when calling getSharedDispositionDocumentApiV1PublicDispositionsDispositionIdSharedDocumentsDocIdGet.');
        }

        if (requestParameters.docId === null || requestParameters.docId === undefined) {
            throw new runtime.RequiredError('docId','Required parameter requestParameters.docId was null or undefined when calling getSharedDispositionDocumentApiV1PublicDispositionsDispositionIdSharedDocumentsDocIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/dispositions/{disposition_id}/shared-documents/{doc_id}`.replace(`{${"disposition_id"}}`, encodeURIComponent(String(requestParameters.dispositionId))).replace(`{${"doc_id"}}`, encodeURIComponent(String(requestParameters.docId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stream one shared listing document to an anonymous buyer agent.  Streams the current version after rechecking the same visibility and storage policy as the list. Uploads and signing changes become visible without another sharing action.
     * Get Shared Disposition Document
     */
    async getSharedDispositionDocumentApiV1PublicDispositionsDispositionIdSharedDocumentsDocIdGet(requestParameters: GetSharedDispositionDocumentApiV1PublicDispositionsDispositionIdSharedDocumentsDocIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getSharedDispositionDocumentApiV1PublicDispositionsDispositionIdSharedDocumentsDocIdGetRaw(requestParameters, initOverrides);
    }

    /**
     * Get User License
     */
    async getUserLicenseApiV1PublicUsersUserIdLicenseGetRaw(requestParameters: GetUserLicenseApiV1PublicUsersUserIdLicenseGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicUserLicenseInfo>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserLicenseApiV1PublicUsersUserIdLicenseGet.');
        }

        if (requestParameters.state === null || requestParameters.state === undefined) {
            throw new runtime.RequiredError('state','Required parameter requestParameters.state was null or undefined when calling getUserLicenseApiV1PublicUsersUserIdLicenseGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/users/{user_id}/license`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicUserLicenseInfoFromJSON(jsonValue));
    }

    /**
     * Get User License
     */
    async getUserLicenseApiV1PublicUsersUserIdLicenseGet(requestParameters: GetUserLicenseApiV1PublicUsersUserIdLicenseGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicUserLicenseInfo> {
        const response = await this.getUserLicenseApiV1PublicUsersUserIdLicenseGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * \"Talk to a real estate advisor\" (TXN-3529): records the resident\'s contact and consent like the interest form (not interest) and raises one call task for the listing coordinator, due in 90 business minutes. Returns the page.  Same token, 404 and lockout rules as the page. 409 unless the page is on `interest` or `terms`; 422 unless a valid phone and `consent_accepted` come with it. Repeating it while the call task is open creates no second task.
     * Homeownership Advisor Request
     */
    async homeownershipAdvisorRequestApiV1PublicHomeownershipAdvisorRequestPostRaw(requestParameters: HomeownershipAdvisorRequestApiV1PublicHomeownershipAdvisorRequestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipAdvisorRequest === null || requestParameters.homeownershipAdvisorRequest === undefined) {
            throw new runtime.RequiredError('homeownershipAdvisorRequest','Required parameter requestParameters.homeownershipAdvisorRequest was null or undefined when calling homeownershipAdvisorRequestApiV1PublicHomeownershipAdvisorRequestPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/advisor-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipAdvisorRequestToJSON(requestParameters.homeownershipAdvisorRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * \"Talk to a real estate advisor\" (TXN-3529): records the resident\'s contact and consent like the interest form (not interest) and raises one call task for the listing coordinator, due in 90 business minutes. Returns the page.  Same token, 404 and lockout rules as the page. 409 unless the page is on `interest` or `terms`; 422 unless a valid phone and `consent_accepted` come with it. Repeating it while the call task is open creates no second task.
     * Homeownership Advisor Request
     */
    async homeownershipAdvisorRequestApiV1PublicHomeownershipAdvisorRequestPost(requestParameters: HomeownershipAdvisorRequestApiV1PublicHomeownershipAdvisorRequestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipAdvisorRequestApiV1PublicHomeownershipAdvisorRequestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * \"Changed your mind? Back to your offer\" (TXN-3503): a no at interest is cleared, a declined price goes back to sent; returns the refreshed page (`interest`, `terms` or `accepted`).  Same token, 404 and lockout rules as the page. 409 unless the page\'s `can_change_mind` is true: the home is still in first look, nothing past the no (no lock, no last look) and, for a price, its window has not ended. Stops the open pass task and records the timeline line; sends no email.
     * Homeownership Change Mind
     */
    async homeownershipChangeMindApiV1PublicHomeownershipChangeMindPostRaw(requestParameters: HomeownershipChangeMindApiV1PublicHomeownershipChangeMindPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipPageRequest === null || requestParameters.homeownershipPageRequest === undefined) {
            throw new runtime.RequiredError('homeownershipPageRequest','Required parameter requestParameters.homeownershipPageRequest was null or undefined when calling homeownershipChangeMindApiV1PublicHomeownershipChangeMindPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/change-mind`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipPageRequestToJSON(requestParameters.homeownershipPageRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * \"Changed your mind? Back to your offer\" (TXN-3503): a no at interest is cleared, a declined price goes back to sent; returns the refreshed page (`interest`, `terms` or `accepted`).  Same token, 404 and lockout rules as the page. 409 unless the page\'s `can_change_mind` is true: the home is still in first look, nothing past the no (no lock, no last look) and, for a price, its window has not ended. Stops the open pass task and records the timeline line; sends no email.
     * Homeownership Change Mind
     */
    async homeownershipChangeMindApiV1PublicHomeownershipChangeMindPost(requestParameters: HomeownershipChangeMindApiV1PublicHomeownershipChangeMindPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipChangeMindApiV1PublicHomeownershipChangeMindPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The resident withdraws their consent on one channel (email, call or text), TXN-3476; returns the refreshed page.  Same token, 404 and lockout rules as the page. 409 with no consented contact on file; withdrawing a channel already withdrawn returns the page unchanged. It is recorded (with compliance evidence) and shown to the owner and to Mainstay; it holds no email back, and the resident\'s accept and decline still count.
     * Homeownership Consent Withdraw
     */
    async homeownershipConsentWithdrawApiV1PublicHomeownershipConsentWithdrawPostRaw(requestParameters: HomeownershipConsentWithdrawApiV1PublicHomeownershipConsentWithdrawPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipConsentWithdrawRequest === null || requestParameters.homeownershipConsentWithdrawRequest === undefined) {
            throw new runtime.RequiredError('homeownershipConsentWithdrawRequest','Required parameter requestParameters.homeownershipConsentWithdrawRequest was null or undefined when calling homeownershipConsentWithdrawApiV1PublicHomeownershipConsentWithdrawPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/consent/withdraw`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipConsentWithdrawRequestToJSON(requestParameters.homeownershipConsentWithdrawRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * The resident withdraws their consent on one channel (email, call or text), TXN-3476; returns the refreshed page.  Same token, 404 and lockout rules as the page. 409 with no consented contact on file; withdrawing a channel already withdrawn returns the page unchanged. It is recorded (with compliance evidence) and shown to the owner and to Mainstay; it holds no email back, and the resident\'s accept and decline still count.
     * Homeownership Consent Withdraw
     */
    async homeownershipConsentWithdrawApiV1PublicHomeownershipConsentWithdrawPost(requestParameters: HomeownershipConsentWithdrawApiV1PublicHomeownershipConsentWithdrawPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipConsentWithdrawApiV1PublicHomeownershipConsentWithdrawPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * \"Yes, I\'m interested\": records the resident and their consent, returns the refreshed page.  Same token, 404 and lockout rules as the page. 409 unless the page is on `interest`; 422 unless `consent_accepted` is true. Repeating it while still on `interest` is idempotent.
     * Homeownership Interest
     */
    async homeownershipInterestApiV1PublicHomeownershipInterestPostRaw(requestParameters: HomeownershipInterestApiV1PublicHomeownershipInterestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipInterestRequest === null || requestParameters.homeownershipInterestRequest === undefined) {
            throw new runtime.RequiredError('homeownershipInterestRequest','Required parameter requestParameters.homeownershipInterestRequest was null or undefined when calling homeownershipInterestApiV1PublicHomeownershipInterestPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/interest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipInterestRequestToJSON(requestParameters.homeownershipInterestRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * \"Yes, I\'m interested\": records the resident and their consent, returns the refreshed page.  Same token, 404 and lockout rules as the page. 409 unless the page is on `interest`; 422 unless `consent_accepted` is true. Repeating it while still on `interest` is idempotent.
     * Homeownership Interest
     */
    async homeownershipInterestApiV1PublicHomeownershipInterestPost(requestParameters: HomeownershipInterestApiV1PublicHomeownershipInterestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipInterestApiV1PublicHomeownershipInterestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The resident\'s answer to the open last look, `match` or `pass`; returns the refreshed page.  Same token, 404 and lockout rules as the page. 409 unless the page is on `last_look` and `last_look_id` is the open one. Answering the same way again returns the page unchanged; a different answer to an answered last look is a 409. A match moves the page to `accepted`.
     * Homeownership Last Look Answer
     */
    async homeownershipLastLookAnswerApiV1PublicHomeownershipLastLookAnswerPostRaw(requestParameters: HomeownershipLastLookAnswerApiV1PublicHomeownershipLastLookAnswerPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipLastLookAnswerRequest === null || requestParameters.homeownershipLastLookAnswerRequest === undefined) {
            throw new runtime.RequiredError('homeownershipLastLookAnswerRequest','Required parameter requestParameters.homeownershipLastLookAnswerRequest was null or undefined when calling homeownershipLastLookAnswerApiV1PublicHomeownershipLastLookAnswerPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/last-look/answer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipLastLookAnswerRequestToJSON(requestParameters.homeownershipLastLookAnswerRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * The resident\'s answer to the open last look, `match` or `pass`; returns the refreshed page.  Same token, 404 and lockout rules as the page. 409 unless the page is on `last_look` and `last_look_id` is the open one. Answering the same way again returns the page unchanged; a different answer to an answered last look is a 409. A match moves the page to `accepted`.
     * Homeownership Last Look Answer
     */
    async homeownershipLastLookAnswerApiV1PublicHomeownershipLastLookAnswerPost(requestParameters: HomeownershipLastLookAnswerApiV1PublicHomeownershipLastLookAnswerPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipLastLookAnswerApiV1PublicHomeownershipLastLookAnswerPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The text of the consent to share a resident\'s contact with a partner lender (TXN-3532), as plain text: the stable URL sent to the lender with each lead (`consent_language_url`). The path names the version, and the text served is exactly that version\'s (what the leads recorded under it showed); a version that never existed or an unknown connection is a 404. No token, no login: it is the same sentence every resident is shown, with the lender\'s name filled in.
     * Homeownership Lender Consent
     */
    async homeownershipLenderConsentApiV1PublicHomeownershipConsentLenderVVersionConnectionGetRaw(requestParameters: HomeownershipLenderConsentApiV1PublicHomeownershipConsentLenderVVersionConnectionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version','Required parameter requestParameters.version was null or undefined when calling homeownershipLenderConsentApiV1PublicHomeownershipConsentLenderVVersionConnectionGet.');
        }

        if (requestParameters.connection === null || requestParameters.connection === undefined) {
            throw new runtime.RequiredError('connection','Required parameter requestParameters.connection was null or undefined when calling homeownershipLenderConsentApiV1PublicHomeownershipConsentLenderVVersionConnectionGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/homeownership/consent/lender/v{version}/{connection}`.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"connection"}}`, encodeURIComponent(String(requestParameters.connection))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * The text of the consent to share a resident\'s contact with a partner lender (TXN-3532), as plain text: the stable URL sent to the lender with each lead (`consent_language_url`). The path names the version, and the text served is exactly that version\'s (what the leads recorded under it showed); a version that never existed or an unknown connection is a 404. No token, no login: it is the same sentence every resident is shown, with the lender\'s name filled in.
     * Homeownership Lender Consent
     */
    async homeownershipLenderConsentApiV1PublicHomeownershipConsentLenderVVersionConnectionGet(requestParameters: HomeownershipLenderConsentApiV1PublicHomeownershipConsentLenderVVersionConnectionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.homeownershipLenderConsentApiV1PublicHomeownershipConsentLenderVVersionConnectionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A lender button for an API lender (TXN-3532): records the resident\'s contact and their consent to share it with the lender, queues one lead for the lender, and returns the page. The lead is sent later by a background job; the resident never sees a lender error.  Same token, 404 and lockout rules as the page. 409 unless the page shows a lender button (`interest`, `terms`, `declined`, or `closed` after a no at the interest stage) or the lender is not an API lender the page shows; 422 unless a valid phone, `consent_accepted` and `lender_consent_version` come with it, and 409 when that version is no longer the current consent text (the page reloads and the resident reads it again). A repeat for the same sale and lender queues nothing new.
     * Homeownership Lender Request
     */
    async homeownershipLenderRequestApiV1PublicHomeownershipLenderRequestPostRaw(requestParameters: HomeownershipLenderRequestApiV1PublicHomeownershipLenderRequestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipLenderRequest === null || requestParameters.homeownershipLenderRequest === undefined) {
            throw new runtime.RequiredError('homeownershipLenderRequest','Required parameter requestParameters.homeownershipLenderRequest was null or undefined when calling homeownershipLenderRequestApiV1PublicHomeownershipLenderRequestPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/lender-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipLenderRequestToJSON(requestParameters.homeownershipLenderRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * A lender button for an API lender (TXN-3532): records the resident\'s contact and their consent to share it with the lender, queues one lead for the lender, and returns the page. The lead is sent later by a background job; the resident never sees a lender error.  Same token, 404 and lockout rules as the page. 409 unless the page shows a lender button (`interest`, `terms`, `declined`, or `closed` after a no at the interest stage) or the lender is not an API lender the page shows; 422 unless a valid phone, `consent_accepted` and `lender_consent_version` come with it, and 409 when that version is no longer the current consent text (the page reloads and the resident reads it again). A repeat for the same sale and lender queues nothing new.
     * Homeownership Lender Request
     */
    async homeownershipLenderRequestApiV1PublicHomeownershipLenderRequestPost(requestParameters: HomeownershipLenderRequestApiV1PublicHomeownershipLenderRequestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipLenderRequestApiV1PublicHomeownershipLenderRequestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The lock wizard\'s last step: records the resident\'s submitted interest (TXN-3478: an expression of interest, nothing to sign) and returns the refreshed page (`locked`).  Same token, 404 and lockout rules as the page. 422 unless `loi_accepted` is true, for `representation` `none` (removed by TXN-3478), for the Mainstay agent while that option is off, and for `lender_consent` unless `financing` is `partner` and the version\'s partner lender is an API lender (TXN-3532: the lead for it is recorded once the lock is). 409 unless the page is on `terms` or `accepted` and `terms_id` is the current sent version, when `loi_version` or `contract_deadline_days` (null when the owner set no deadline) is not current, or when there is no contact on file. Submitting again once `locked` returns the page unchanged.
     * Homeownership Lock
     */
    async homeownershipLockApiV1PublicHomeownershipLockPostRaw(requestParameters: HomeownershipLockApiV1PublicHomeownershipLockPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipLockRequest === null || requestParameters.homeownershipLockRequest === undefined) {
            throw new runtime.RequiredError('homeownershipLockRequest','Required parameter requestParameters.homeownershipLockRequest was null or undefined when calling homeownershipLockApiV1PublicHomeownershipLockPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/lock`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipLockRequestToJSON(requestParameters.homeownershipLockRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * The lock wizard\'s last step: records the resident\'s submitted interest (TXN-3478: an expression of interest, nothing to sign) and returns the refreshed page (`locked`).  Same token, 404 and lockout rules as the page. 422 unless `loi_accepted` is true, for `representation` `none` (removed by TXN-3478), for the Mainstay agent while that option is off, and for `lender_consent` unless `financing` is `partner` and the version\'s partner lender is an API lender (TXN-3532: the lead for it is recorded once the lock is). 409 unless the page is on `terms` or `accepted` and `terms_id` is the current sent version, when `loi_version` or `contract_deadline_days` (null when the owner set no deadline) is not current, or when there is no contact on file. Submitting again once `locked` returns the page unchanged.
     * Homeownership Lock
     */
    async homeownershipLockApiV1PublicHomeownershipLockPost(requestParameters: HomeownershipLockApiV1PublicHomeownershipLockPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipLockApiV1PublicHomeownershipLockPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The resident opts out of Mainstay\'s messages about their home (TXN-3510): the footer link of every email opens a one-step confirm page that posts here with the link token; returns the refreshed page.  Same 404 and lockout rules as the page, except that a revoked or expired link still works (legal: the opt-out in any past email must). 409 with no contact on file. Email, call and text are withdrawn together (recorded with compliance evidence and a timeline line); every later DTR email to the resident is refused, and the open call and follow-up are stopped. Opting out again returns the page unchanged. The AOL gets one task to continue contact through the owner. The resident\'s accept, decline and lock still count.
     * Homeownership Opt Out
     */
    async homeownershipOptOutApiV1PublicHomeownershipOptOutPostRaw(requestParameters: HomeownershipOptOutApiV1PublicHomeownershipOptOutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipPageRequest === null || requestParameters.homeownershipPageRequest === undefined) {
            throw new runtime.RequiredError('homeownershipPageRequest','Required parameter requestParameters.homeownershipPageRequest was null or undefined when calling homeownershipOptOutApiV1PublicHomeownershipOptOutPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/opt-out`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipPageRequestToJSON(requestParameters.homeownershipPageRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * The resident opts out of Mainstay\'s messages about their home (TXN-3510): the footer link of every email opens a one-step confirm page that posts here with the link token; returns the refreshed page.  Same 404 and lockout rules as the page, except that a revoked or expired link still works (legal: the opt-out in any past email must). 409 with no contact on file. Email, call and text are withdrawn together (recorded with compliance evidence and a timeline line); every later DTR email to the resident is refused, and the open call and follow-up are stopped. Opting out again returns the page unchanged. The AOL gets one task to continue contact through the owner. The resident\'s accept, decline and lock still count.
     * Homeownership Opt Out
     */
    async homeownershipOptOutApiV1PublicHomeownershipOptOutPost(requestParameters: HomeownershipOptOutApiV1PublicHomeownershipOptOutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipOptOutApiV1PublicHomeownershipOptOutPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The page behind the opt-out confirm screen (TXN-3510): the same as `/page`, but a link a newer email revoked still opens it, so the opt-out in any past email works. Unknown tokens are a 404 with the same lockout.
     * Homeownership Opt Out Page
     */
    async homeownershipOptOutPageApiV1PublicHomeownershipOptOutPagePostRaw(requestParameters: HomeownershipOptOutPageApiV1PublicHomeownershipOptOutPagePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipPageRequest === null || requestParameters.homeownershipPageRequest === undefined) {
            throw new runtime.RequiredError('homeownershipPageRequest','Required parameter requestParameters.homeownershipPageRequest was null or undefined when calling homeownershipOptOutPageApiV1PublicHomeownershipOptOutPagePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/opt-out/page`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipPageRequestToJSON(requestParameters.homeownershipPageRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * The page behind the opt-out confirm screen (TXN-3510): the same as `/page`, but a link a newer email revoked still opens it, so the opt-out in any past email works. Unknown tokens are a 404 with the same lockout.
     * Homeownership Opt Out Page
     */
    async homeownershipOptOutPageApiV1PublicHomeownershipOptOutPagePost(requestParameters: HomeownershipOptOutPageApiV1PublicHomeownershipOptOutPagePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipOptOutPageApiV1PublicHomeownershipOptOutPagePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The resident page for a link token (the token is in the body, never in a URL).  Any token that is unknown, expired or revoked is the same 404. After 20 bad tokens from one IP in 15 minutes, that IP gets 429 for the rest of the window, valid token or not.
     * Homeownership Page
     */
    async homeownershipPageApiV1PublicHomeownershipPagePostRaw(requestParameters: HomeownershipPageApiV1PublicHomeownershipPagePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipPageRequest === null || requestParameters.homeownershipPageRequest === undefined) {
            throw new runtime.RequiredError('homeownershipPageRequest','Required parameter requestParameters.homeownershipPageRequest was null or undefined when calling homeownershipPageApiV1PublicHomeownershipPagePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/page`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipPageRequestToJSON(requestParameters.homeownershipPageRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * The resident page for a link token (the token is in the body, never in a URL).  Any token that is unknown, expired or revoked is the same 404. After 20 bad tokens from one IP in 15 minutes, that IP gets 429 for the rest of the window, valid token or not.
     * Homeownership Page
     */
    async homeownershipPageApiV1PublicHomeownershipPagePost(requestParameters: HomeownershipPageApiV1PublicHomeownershipPagePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipPageApiV1PublicHomeownershipPagePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The resident really opened the page: counts one open of the link and, on its first, writes the timeline\'s \"opened\" activity (TXN-3314). The page sends it on the resident\'s first interaction while it is visible, or after 20 seconds visible; reading the page alone counts nothing, so an email scanner that renders it and leaves is not an open.  Same token, 404 and lockout rules as the page. A known scanner user agent gets the same 204 and counts nothing.
     * Homeownership Page Opened
     */
    async homeownershipPageOpenedApiV1PublicHomeownershipPageOpenedPostRaw(requestParameters: HomeownershipPageOpenedApiV1PublicHomeownershipPageOpenedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.homeownershipPageRequest === null || requestParameters.homeownershipPageRequest === undefined) {
            throw new runtime.RequiredError('homeownershipPageRequest','Required parameter requestParameters.homeownershipPageRequest was null or undefined when calling homeownershipPageOpenedApiV1PublicHomeownershipPageOpenedPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/page/opened`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipPageRequestToJSON(requestParameters.homeownershipPageRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * The resident really opened the page: counts one open of the link and, on its first, writes the timeline\'s \"opened\" activity (TXN-3314). The page sends it on the resident\'s first interaction while it is visible, or after 20 seconds visible; reading the page alone counts nothing, so an email scanner that renders it and leaves is not an open.  Same token, 404 and lockout rules as the page. A known scanner user agent gets the same 204 and counts nothing.
     * Homeownership Page Opened
     */
    async homeownershipPageOpenedApiV1PublicHomeownershipPageOpenedPost(requestParameters: HomeownershipPageOpenedApiV1PublicHomeownershipPageOpenedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.homeownershipPageOpenedApiV1PublicHomeownershipPageOpenedPostRaw(requestParameters, initOverrides);
    }

    /**
     * \"No thanks\": ends the sale as not interested and returns the refreshed (closed) page.  Same token, 404 and lockout rules as the page. 409 unless the page is on `interest`; passing again after a pass returns the page unchanged. No contact is needed; a contact the resident leaves (an email or phone) needs `name`, `email` and `consent_accepted` (422 otherwise) and is recorded first.
     * Homeownership Pass
     */
    async homeownershipPassApiV1PublicHomeownershipPassPostRaw(requestParameters: HomeownershipPassApiV1PublicHomeownershipPassPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipPassRequest === null || requestParameters.homeownershipPassRequest === undefined) {
            throw new runtime.RequiredError('homeownershipPassRequest','Required parameter requestParameters.homeownershipPassRequest was null or undefined when calling homeownershipPassApiV1PublicHomeownershipPassPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/pass`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipPassRequestToJSON(requestParameters.homeownershipPassRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * \"No thanks\": ends the sale as not interested and returns the refreshed (closed) page.  Same token, 404 and lockout rules as the page. 409 unless the page is on `interest`; passing again after a pass returns the page unchanged. No contact is needed; a contact the resident leaves (an email or phone) needs `name`, `email` and `consent_accepted` (422 otherwise) and is recorded first.
     * Homeownership Pass
     */
    async homeownershipPassApiV1PublicHomeownershipPassPost(requestParameters: HomeownershipPassApiV1PublicHomeownershipPassPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipPassApiV1PublicHomeownershipPassPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A non-binding yes to the sent price (not the lock); returns the refreshed page (`accepted`).  Same token, 404 and lockout rules as the page. 409 unless the page is on `terms` and `terms_id` is the current sent version; accepting again from `accepted` returns the page unchanged. With no resident on file, `name`, `email` and `consent_accepted` are required (422 otherwise) and recorded first, as interest records them; with one on file they are ignored.
     * Homeownership Terms Accept
     */
    async homeownershipTermsAcceptApiV1PublicHomeownershipTermsAcceptPostRaw(requestParameters: HomeownershipTermsAcceptApiV1PublicHomeownershipTermsAcceptPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipTermsAcceptRequest === null || requestParameters.homeownershipTermsAcceptRequest === undefined) {
            throw new runtime.RequiredError('homeownershipTermsAcceptRequest','Required parameter requestParameters.homeownershipTermsAcceptRequest was null or undefined when calling homeownershipTermsAcceptApiV1PublicHomeownershipTermsAcceptPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/terms/accept`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipTermsAcceptRequestToJSON(requestParameters.homeownershipTermsAcceptRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * A non-binding yes to the sent price (not the lock); returns the refreshed page (`accepted`).  Same token, 404 and lockout rules as the page. 409 unless the page is on `terms` and `terms_id` is the current sent version; accepting again from `accepted` returns the page unchanged. With no resident on file, `name`, `email` and `consent_accepted` are required (422 otherwise) and recorded first, as interest records them; with one on file they are ignored.
     * Homeownership Terms Accept
     */
    async homeownershipTermsAcceptApiV1PublicHomeownershipTermsAcceptPost(requestParameters: HomeownershipTermsAcceptApiV1PublicHomeownershipTermsAcceptPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipTermsAcceptApiV1PublicHomeownershipTermsAcceptPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The resident passes on the sent price, with an optional reason; returns the refreshed page (`declined`).  Same token, 404 and lockout rules as the page. 409 unless the page is on `terms` or `accepted` and `terms_id` is the current sent version; declining again from `declined` returns the page unchanged. Contact fields as for accept, except that none is needed (TXN-3475): with no email or phone given the decline is recorded with no contact and no consent.
     * Homeownership Terms Decline
     */
    async homeownershipTermsDeclineApiV1PublicHomeownershipTermsDeclinePostRaw(requestParameters: HomeownershipTermsDeclineApiV1PublicHomeownershipTermsDeclinePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeownershipPageResponse>> {
        if (requestParameters.homeownershipTermsDeclineRequest === null || requestParameters.homeownershipTermsDeclineRequest === undefined) {
            throw new runtime.RequiredError('homeownershipTermsDeclineRequest','Required parameter requestParameters.homeownershipTermsDeclineRequest was null or undefined when calling homeownershipTermsDeclineApiV1PublicHomeownershipTermsDeclinePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/homeownership/terms/decline`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HomeownershipTermsDeclineRequestToJSON(requestParameters.homeownershipTermsDeclineRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeownershipPageResponseFromJSON(jsonValue));
    }

    /**
     * The resident passes on the sent price, with an optional reason; returns the refreshed page (`declined`).  Same token, 404 and lockout rules as the page. 409 unless the page is on `terms` or `accepted` and `terms_id` is the current sent version; declining again from `declined` returns the page unchanged. Contact fields as for accept, except that none is needed (TXN-3475): with no email or phone given the decline is recorded with no contact and no consent.
     * Homeownership Terms Decline
     */
    async homeownershipTermsDeclineApiV1PublicHomeownershipTermsDeclinePost(requestParameters: HomeownershipTermsDeclineApiV1PublicHomeownershipTermsDeclinePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeownershipPageResponse> {
        const response = await this.homeownershipTermsDeclineApiV1PublicHomeownershipTermsDeclinePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the buyer-visible documents on the buyer\'s own transaction.  `TransactionResponse.document_count` says how many documents exist but not which, so without this the download route below would have nothing to link to. Session-authed and ownership-checked; the response carries only the fields needed to identify and fetch a file (see `PublicTransactionDocumentResponse` for what is withheld and why).
     * List Public Transaction Documents
     */
    async listPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsGetRaw(requestParameters: ListPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PublicTransactionDocumentResponse>>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling listPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/transactions/{transaction_id}/documents`.replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PublicTransactionDocumentResponseFromJSON));
    }

    /**
     * List the buyer-visible documents on the buyer\'s own transaction.  `TransactionResponse.document_count` says how many documents exist but not which, so without this the download route below would have nothing to link to. Session-authed and ownership-checked; the response carries only the fields needed to identify and fetch a file (see `PublicTransactionDocumentResponse` for what is withheld and why).
     * List Public Transaction Documents
     */
    async listPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsGet(requestParameters: ListPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PublicTransactionDocumentResponse>> {
        const response = await this.listPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The listing documents a seller-side operator chose to show buyer agents on the offer form (\"Required documents\").  Anonymous, like the form itself: NO org context is read here and none may be added. `httpserver.py` seeds an org ctx from `x-amzn-oidc-identity` on every request, so on a public route a forged header resolves to a real org -- visibility is decided entirely by `MtxDocRepository.list_buyer_shared`, the one predicate the download route shares. A missing, terminal or share-less listing is an empty list, not a 404, so the route is not an oracle for which listings exist.
     * List Shared Disposition Documents
     */
    async listSharedDispositionDocumentsApiV1PublicDispositionsDispositionIdSharedDocumentsGetRaw(requestParameters: ListSharedDispositionDocumentsApiV1PublicDispositionsDispositionIdSharedDocumentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PublicSharedDocumentResponse>>> {
        if (requestParameters.dispositionId === null || requestParameters.dispositionId === undefined) {
            throw new runtime.RequiredError('dispositionId','Required parameter requestParameters.dispositionId was null or undefined when calling listSharedDispositionDocumentsApiV1PublicDispositionsDispositionIdSharedDocumentsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/dispositions/{disposition_id}/shared-documents`.replace(`{${"disposition_id"}}`, encodeURIComponent(String(requestParameters.dispositionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PublicSharedDocumentResponseFromJSON));
    }

    /**
     * The listing documents a seller-side operator chose to show buyer agents on the offer form (\"Required documents\").  Anonymous, like the form itself: NO org context is read here and none may be added. `httpserver.py` seeds an org ctx from `x-amzn-oidc-identity` on every request, so on a public route a forged header resolves to a real org -- visibility is decided entirely by `MtxDocRepository.list_buyer_shared`, the one predicate the download route shares. A missing, terminal or share-less listing is an empty list, not a 404, so the route is not an oracle for which listings exist.
     * List Shared Disposition Documents
     */
    async listSharedDispositionDocumentsApiV1PublicDispositionsDispositionIdSharedDocumentsGet(requestParameters: ListSharedDispositionDocumentsApiV1PublicDispositionsDispositionIdSharedDocumentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PublicSharedDocumentResponse>> {
        const response = await this.listSharedDispositionDocumentsApiV1PublicDispositionsDispositionIdSharedDocumentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Logout Session
     */
    async logoutSessionApiV1PublicAuthLogoutPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/auth/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Logout Session
     */
    async logoutSessionApiV1PublicAuthLogoutPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.logoutSessionApiV1PublicAuthLogoutPostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Prewalk Agent Results
     */
    async prewalkAgentResultsApiV1PublicPrewalkAgentResultsPostRaw(requestParameters: PrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost>> {
        if (requestParameters.prewalkAgentResultsRequest === null || requestParameters.prewalkAgentResultsRequest === undefined) {
            throw new runtime.RequiredError('prewalkAgentResultsRequest','Required parameter requestParameters.prewalkAgentResultsRequest was null or undefined when calling prewalkAgentResultsApiV1PublicPrewalkAgentResultsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/prewalk-agent-results`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrewalkAgentResultsRequestToJSON(requestParameters.prewalkAgentResultsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostFromJSON(jsonValue));
    }

    /**
     * Prewalk Agent Results
     */
    async prewalkAgentResultsApiV1PublicPrewalkAgentResultsPost(requestParameters: PrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost> {
        const response = await this.prewalkAgentResultsApiV1PublicPrewalkAgentResultsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send Auth Token Email
     */
    async sendAuthTokenEmailApiV1PublicAuthEmailGetRaw(requestParameters: SendAuthTokenEmailApiV1PublicAuthEmailGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.email === null || requestParameters.email === undefined) {
            throw new runtime.RequiredError('email','Required parameter requestParameters.email was null or undefined when calling sendAuthTokenEmailApiV1PublicAuthEmailGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.redirectUrl !== undefined) {
            queryParameters['redirect_url'] = requestParameters.redirectUrl;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/auth/email`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Send Auth Token Email
     */
    async sendAuthTokenEmailApiV1PublicAuthEmailGet(requestParameters: SendAuthTokenEmailApiV1PublicAuthEmailGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.sendAuthTokenEmailApiV1PublicAuthEmailGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Offer
     */
    async updateOfferApiV1PublicOffersOfferIdPatchRaw(requestParameters: UpdateOfferApiV1PublicOffersOfferIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Offer>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling updateOfferApiV1PublicOffersOfferIdPatch.');
        }

        if (requestParameters.publicUpdateOfferRequest === null || requestParameters.publicUpdateOfferRequest === undefined) {
            throw new runtime.RequiredError('publicUpdateOfferRequest','Required parameter requestParameters.publicUpdateOfferRequest was null or undefined when calling updateOfferApiV1PublicOffersOfferIdPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/offers/{offer_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PublicUpdateOfferRequestToJSON(requestParameters.publicUpdateOfferRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OfferFromJSON(jsonValue));
    }

    /**
     * Update Offer
     */
    async updateOfferApiV1PublicOffersOfferIdPatch(requestParameters: UpdateOfferApiV1PublicOffersOfferIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Offer> {
        const response = await this.updateOfferApiV1PublicOffersOfferIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Offer Terms
     */
    async updateOfferTermsApiV1PublicOffersTermsTermsIdPatchRaw(requestParameters: UpdateOfferTermsApiV1PublicOffersTermsTermsIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferTerms>> {
        if (requestParameters.termsId === null || requestParameters.termsId === undefined) {
            throw new runtime.RequiredError('termsId','Required parameter requestParameters.termsId was null or undefined when calling updateOfferTermsApiV1PublicOffersTermsTermsIdPatch.');
        }

        if (requestParameters.updateOfferTermsRequest === null || requestParameters.updateOfferTermsRequest === undefined) {
            throw new runtime.RequiredError('updateOfferTermsRequest','Required parameter requestParameters.updateOfferTermsRequest was null or undefined when calling updateOfferTermsApiV1PublicOffersTermsTermsIdPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/public/offers/terms/{terms_id}`.replace(`{${"terms_id"}}`, encodeURIComponent(String(requestParameters.termsId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOfferTermsRequestToJSON(requestParameters.updateOfferTermsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OfferTermsFromJSON(jsonValue));
    }

    /**
     * Update Offer Terms
     */
    async updateOfferTermsApiV1PublicOffersTermsTermsIdPatch(requestParameters: UpdateOfferTermsApiV1PublicOffersTermsTermsIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferTerms> {
        const response = await this.updateOfferTermsApiV1PublicOffersTermsTermsIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 1.0 buyer document upload.  Reads no session: this route has never consulted the cookie, and MTX 1.0 keeps behaving as it does today until the plane freezes.
     * Upload Offer Documents
     */
    async uploadOfferDocumentsApiV1PublicOffersOfferIdDocumentsPostRaw(requestParameters: UploadOfferDocumentsApiV1PublicOffersOfferIdDocumentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadOfferDocumentsResponse>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling uploadOfferDocumentsApiV1PublicOffersOfferIdDocumentsPost.');
        }

        if (requestParameters.files === null || requestParameters.files === undefined) {
            throw new runtime.RequiredError('files','Required parameter requestParameters.files was null or undefined when calling uploadOfferDocumentsApiV1PublicOffersOfferIdDocumentsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.files) {
            requestParameters.files.forEach((element) => {
                formParams.append('files', element as any);
            })
        }

        const response = await this.request({
            path: `/api/v1/public/offers/{offer_id}/documents`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadOfferDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * 1.0 buyer document upload.  Reads no session: this route has never consulted the cookie, and MTX 1.0 keeps behaving as it does today until the plane freezes.
     * Upload Offer Documents
     */
    async uploadOfferDocumentsApiV1PublicOffersOfferIdDocumentsPost(requestParameters: UploadOfferDocumentsApiV1PublicOffersOfferIdDocumentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadOfferDocumentsResponse> {
        const response = await this.uploadOfferDocumentsApiV1PublicOffersOfferIdDocumentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public buyer document upload for a transaction — one file per request.  Mirrors the 1.0 ``POST /offers/{offer_id}/documents`` (unauth allowed). When a session cookie is present we validate the PublicUser owns the transaction; otherwise the upload is permitted, matching the 1.0 public doc upload. Docs attach transaction-scoped via the unified pipeline (``mtx_docs.transaction_id``), stamped with the AVA system user as actor since consumers carry no MTX user.  One request per file (rather than a batch call) is deliberate: it\'s simpler on both ends and gives per-file error handling, so one bad file doesn\'t sink the whole batch. The caller (the public offers form) is expected to call this once per selected file, each with its own ``doc_type``.
     * Upload Public Transaction Documents
     */
    async uploadPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsPostRaw(requestParameters: UploadPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadOfferDocumentsResponse>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling uploadPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsPost.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        if (requestParameters.docType !== undefined) {
            formParams.append('doc_type', requestParameters.docType as any);
        }

        const response = await this.request({
            path: `/api/v1/public/transactions/{transaction_id}/documents`.replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadOfferDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * Public buyer document upload for a transaction — one file per request.  Mirrors the 1.0 ``POST /offers/{offer_id}/documents`` (unauth allowed). When a session cookie is present we validate the PublicUser owns the transaction; otherwise the upload is permitted, matching the 1.0 public doc upload. Docs attach transaction-scoped via the unified pipeline (``mtx_docs.transaction_id``), stamped with the AVA system user as actor since consumers carry no MTX user.  One request per file (rather than a batch call) is deliberate: it\'s simpler on both ends and gives per-file error handling, so one bad file doesn\'t sink the whole batch. The caller (the public offers form) is expected to call this once per selected file, each with its own ``doc_type``.
     * Upload Public Transaction Documents
     */
    async uploadPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsPost(requestParameters: UploadPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadOfferDocumentsResponse> {
        const response = await this.uploadPublicTransactionDocumentsApiV1PublicTransactionsTransactionIdDocumentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public buyer withdrawal of their own offer.  Session-authed (magic-link). The 2.0 equivalent of 1.0\'s public `PATCH /offers/{id}` with `status=rejected, statusReason=buyer_withdrawn`, which freezes with the legacy plane and would otherwise take the buyer\'s ability to withdraw with it. A dedicated POST rather than a public PATCH: withdrawal is the only transaction field a buyer may write, and an exposed status PATCH would have to reject every other value it can express.  `_get_owned_transaction` runs first so a missing or someone else\'s transaction answers with this module\'s own 404/403 bodies. `withdraw_transaction` re-checks ownership from the id — it is the service-level gate, not a duplicate of this one — and validates the transition BEFORE mutating, so an illegal withdrawal is a 422 with nothing written.  Returns the same payload as the buyer\'s read, so the client needs no refetch.
     * Withdraw Public Transaction
     */
    async withdrawPublicTransactionApiV1PublicTransactionsTransactionIdWithdrawPostRaw(requestParameters: WithdrawPublicTransactionApiV1PublicTransactionsTransactionIdWithdrawPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionResponse>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling withdrawPublicTransactionApiV1PublicTransactionsTransactionIdWithdrawPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/transactions/{transaction_id}/withdraw`.replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionResponseFromJSON(jsonValue));
    }

    /**
     * Public buyer withdrawal of their own offer.  Session-authed (magic-link). The 2.0 equivalent of 1.0\'s public `PATCH /offers/{id}` with `status=rejected, statusReason=buyer_withdrawn`, which freezes with the legacy plane and would otherwise take the buyer\'s ability to withdraw with it. A dedicated POST rather than a public PATCH: withdrawal is the only transaction field a buyer may write, and an exposed status PATCH would have to reject every other value it can express.  `_get_owned_transaction` runs first so a missing or someone else\'s transaction answers with this module\'s own 404/403 bodies. `withdraw_transaction` re-checks ownership from the id — it is the service-level gate, not a duplicate of this one — and validates the transition BEFORE mutating, so an illegal withdrawal is a 422 with nothing written.  Returns the same payload as the buyer\'s read, so the client needs no refetch.
     * Withdraw Public Transaction
     */
    async withdrawPublicTransactionApiV1PublicTransactionsTransactionIdWithdrawPost(requestParameters: WithdrawPublicTransactionApiV1PublicTransactionsTransactionIdWithdrawPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionResponse> {
        const response = await this.withdrawPublicTransactionApiV1PublicTransactionsTransactionIdWithdrawPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
